export const SVG_NS = 'http://www.w3.org/2000/svg';

export type Attrs = Record<string, string | number>;

/** Create an SVG element, set attributes, and optionally append it. */
export function el<K extends keyof SVGElementTagNameMap>(
  tag: K,
  attrs?: Attrs,
  parent?: Element | null,
): SVGElementTagNameMap[K] {
  const e = document.createElementNS(SVG_NS, tag);
  if (attrs) {
    for (const [k, v] of Object.entries(attrs)) e.setAttribute(k, String(v));
  }
  parent?.appendChild(e);
  return e;
}

/**
 * Same, but with an inline `style`.
 *
 * `var()` only resolves in style declarations, not in presentation
 * attributes — every themed part of a sprite has to go through here.
 */
export function styled<K extends keyof SVGElementTagNameMap>(
  parent: Element | null,
  tag: K,
  attrs: Attrs,
  style: string,
): SVGElementTagNameMap[K] {
  const e = el(tag, attrs, parent);
  e.setAttribute('style', style);
  return e;
}

/** Remove every child of a group. */
export function clear(node: Element): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}
